import * as React from "react";
export const NoImage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    {...props}
  >
    <g
      id="Group_108226"
      data-name="Group 108226"
      transform="translate(-27.25 10.988)"
    >
      <g
        id="Group_108245"
        data-name="Group 108245"
        transform="translate(27.25 -10.988)"
      >
        <rect
          id="Image_17"
          data-name="Image 17"
          width={40}
          height={40}
          rx={4}
          fill="#f2f4f7"
        />
        <g
          id="Group_108257"
          data-name="Group 108257"
          transform="translate(8 8)"
        >
          <rect
            id="Rectangle_55706"
            data-name="Rectangle 55706"
            width={24}
            height={24}
            fill="none"
          />
          <path
            id="icons8-outdoor-swimming-pool_1_"
            data-name="icons8-outdoor-swimming-pool (1)"
            d="M5.362,7A1.664,1.664,0,1,0,7.026,8.664,1.664,1.664,0,0,0,5.362,7Zm8.556,0a2.391,2.391,0,0,0-2.377,2.377v7.605a.951.951,0,1,0,1.9,0V9.377a.461.461,0,0,1,.475-.475h.951a.951.951,0,1,0,0-1.9Zm7.13,0a2.391,2.391,0,0,0-2.377,2.377V10.8H15.344a.951.951,0,1,0,0,1.9h3.327V14.13H15.344a.951.951,0,1,0,0,1.9h3.327v.951a.951.951,0,1,0,1.9,0V15.235a.951.951,0,0,0,0-.308V11.907a.951.951,0,0,0,0-.308V9.377a.461.461,0,0,1,.475-.475H22A.951.951,0,1,0,22,7Zm.989,11.4a.951.951,0,0,0-.453.107,2.639,2.639,0,0,1-.555.167,9.375,9.375,0,0,1-2.119.213,9.375,9.375,0,0,1-2.119-.213,2.155,2.155,0,0,1-.5-.149h0a.951.951,0,0,0-.421-.116h-.054a.951.951,0,0,0-.465.116,2.145,2.145,0,0,1-.5.151,9.372,9.372,0,0,1-2.119.213,9.375,9.375,0,0,1-2.119-.213,2.167,2.167,0,0,1-.5-.15,1,1,0,0,0-.966.014,1.713,1.713,0,0,1-.433.14,7.87,7.87,0,0,1-1.923.209,7.87,7.87,0,0,1-1.923-.209,2.144,2.144,0,0,1-.487-.158A.951.951,0,1,0,3.494,20.2a4.917,4.917,0,0,0,.9.318,9.785,9.785,0,0,0,2.39.266,9.785,9.785,0,0,0,2.39-.266,2.43,2.43,0,0,0,.474-.166,2.762,2.762,0,0,0,.525.17,11.272,11.272,0,0,0,2.552.263,11.272,11.272,0,0,0,2.552-.263,2.805,2.805,0,0,0,.538-.174,2.805,2.805,0,0,0,.538.174,11.272,11.272,0,0,0,2.552.263,11.272,11.272,0,0,0,2.552-.263,5.413,5.413,0,0,0,.953-.308.951.951,0,0,0-.377-1.817Zm0,2.852a.951.951,0,0,0-.453.107,2.639,2.639,0,0,1-.555.167,9.375,9.375,0,0,1-2.119.213,9.375,9.375,0,0,1-2.119-.213,2.155,2.155,0,0,1-.5-.149h0a.951.951,0,0,0-.421-.116h-.054a.951.951,0,0,0-.465.116,2.146,2.146,0,0,1-.5.151,9.372,9.372,0,0,1-2.119.213,9.375,9.375,0,0,1-2.119-.213,2.167,2.167,0,0,1-.5-.15,1,1,0,0,0-.966.014,1.712,1.712,0,0,1-.433.14,7.87,7.87,0,0,1-1.923.209,7.87,7.87,0,0,1-1.923-.209,2.144,2.144,0,0,1-.487-.158.951.951,0,1,0-.884,1.684,4.917,4.917,0,0,0,.9.318,9.785,9.785,0,0,0,2.39.266,9.785,9.785,0,0,0,2.39-.266,2.431,2.431,0,0,0,.474-.166,2.762,2.762,0,0,0,.525.17,11.272,11.272,0,0,0,2.552.263,11.272,11.272,0,0,0,2.552-.263,2.805,2.805,0,0,0,.538-.174,2.805,2.805,0,0,0,.538.174,11.272,11.272,0,0,0,2.552.263,11.272,11.272,0,0,0,2.552-.263,5.413,5.413,0,0,0,.953-.308.951.951,0,0,0-.377-1.817Z"
            transform="translate(-0.972 -3)"
            fill="#ced3dd"
          />
        </g>
      </g>
    </g>
  </svg>
);
